<template>
  <component :is="currentComponent" v-bind="routeProps" />
</template>

<script setup lang="ts">
import { inject, computed, defineAsyncComponent } from 'vue';
import type CustomRouter from './custom-router';

const router = inject<CustomRouter>('router');
const route = inject('route');

// 获取当前组件
const currentComponent = computed(() => {
  if (!router) return null;
  
  const component = router.currentComponent.value;
  
  // 如果是异步组件（通过 import() 导入的），需要用 defineAsyncComponent 包装
  if (typeof component === 'function') {
    return defineAsyncComponent(component);
  }
  
  return component;
});

// 获取路由 props
const routeProps = computed(() => {
  if (!route) return {};
  const routeValue = route.value;
  return {
    ...routeValue.query,
    ...routeValue.params,
  };
});
</script>
